import * as C from '../constants';
import { createAction } from 'redux-actions';
import * as Api from '../api';
import * as ActionCreators from './ActionCreators';

export enum UserFlowType {
  Subscribed = 1,
  PendingDIF = 2,
  EmptyDIF = 3,
  Expired = 4,
}

export const actionUpdateFreeTrialState = createAction(
  C.ACTION_TYPES.FREE_TRIAL_SHOW,
  (state: C.STATE.FREE_TRIAL) => ({ state })
);

export const actionUpdateIsStartFreeTrial = createAction(
  C.ACTION_TYPES.FREE_TRIAL_IS_START,
  (isStart: boolean) => ({ isStart })
);

export const checkUserFlowType = () => async dispatch => {
  const json = await Api.freeTrial.checkUserFlowType();
  const userFlowType: number = json.user_flow_type;
  switch (userFlowType) {
    case UserFlowType.EmptyDIF:
      dispatch(ActionCreators.showModal(ModalType.DIF, null));
      break;
    case UserFlowType.PendingDIF:
      dispatch(ActionCreators.showModal(ModalType.FreeTrial, null));
      break;
    case UserFlowType.Expired:
      dispatch(
        ActionCreators.showModal(ModalType.ExpiredFreeTrialOrSubscription, null)
      );
      break;
    default:
      dispatch(ActionCreators.closeModal());
      break;
  }
  return userFlowType;
};

export const checkPrepopulate = () => async dispatch => {
  const json = await Api.favourite.checkPrepopulate();
  const exists = json.exists;
  if (!exists) {
    dispatch(ActionCreators.showModal(ModalType.Prepopulate, null));
  }
};



// WEBPACK FOOTER //
// ./app/actions/freeTrialActionCreators.ts